module.exports = __webpack_public_path__ + "static/img/bohe.225256c6.png";